import React, { useContext } from 'react';
import { useFela } from 'react-fela';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { ArticleHighlights } from '../components/ArticleHighlights';
import ArticleList from '../components/ArticleList';
import { Box } from '../components/generic/box/box';
import { button } from '../components/generic/nav-button/NavButton.style';
import SectionsList from '../components/SectionsList';
import { ErrorContext } from '../context/ErrorContext';
import { IsLoadingContext } from '../context/IsLoadingContext';
import { ViewContext } from '../context/ViewContext';
import { useFetchFrontpage } from '../utils/useFetchFrontpage';

import type { Theme } from '../types';

export const FrontPage = () => {
  const { isLoading } = useContext(IsLoadingContext);
  const { error } = useContext(ErrorContext);
  const { data } = useContext(ViewContext);
  const { t } = useTranslation();
  const params = useParams();
  const { theme } = useFela<Theme>();

  const fetchFrontpage = useFetchFrontpage();

  return (
    <>
      {isLoading && <p>{t('loading')}</p>}
      {error === 'not_found' && <p>{t('resource_nonexisting')}</p>}
      {error === 'failed' && (
        <>
          <p>{t('unknown_error')}</p>
          <Box as="button" style={button(theme)} onClick={fetchFrontpage}>
            {t('try_again')}
          </Box>
        </>
      )}
      {!isLoading && !!data && (
        <React.Fragment>
          <div className="flex flex-row mt-10">
            <ArticleList viewHash={params.hash ?? ''} articles={data.frontpage} />
            <ArticleHighlights articles={data.highlights} params={params} />
          </div>
          <SectionsList sections={data.sections ?? []} />
        </React.Fragment>
      )}
    </>
  );
};
